export default "__VITE_ASSET__940cbdb4__"